export default {
  ID: 'PENDING_REQUEST',
  PATH: '/pending-request',
  SIDEBAR_IMAGE: true,
  FOOTER: true,
  BUTTON_HELP: true,
  BUTTON_LANG: true,
};
